export default "__VITE_ASSET__B5Pa2Q7T__"